<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="8">
          <el-card>
            <div class="card-header">
              <h4 class="title">Add a new customer</h4>
              <p class="category">Enter new customer details below</p>
              <br />
            </div>
            <div class="card-content">
              <el-form :model="customer" :rules="rules" ref="customer" label-width="120px">
                <el-row>
                  <el-form-item label="Title" prop="title">
                    <el-select
                      size="large"
                      class="form-group border-input"
                      placeholder="Select Title"
                      v-model="customer.title"
                    >
                      <el-option
                        v-for="option in customerTitles"
                        class
                        :value="option"
                        :label="option"
                        :key="option"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Email" prop="email">
                    <el-input
                      type="email"
                      label="Email"
                      placeholder="Email"
                      v-model="customer.email"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="First Name" prop="firstname">
                    <el-input
                      type="text"
                      label="First Name"
                      placeholder="First Name"
                      v-model="customer.firstname"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Last Name" prop="lastname">
                    <el-input
                      type="text"
                      label="Last Name"
                      placeholder="Last Name"
                      v-model="customer.lastname"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Date of Birth" prop="dob">
                    <el-input
                      type="text"
                      label="Date of Birth"
                      placeholder="YYYY-MM-DD"
                      v-mask="'####-##-##'"
                      v-model="customer.dateOfBirth"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Marketing" prop="acceptsMarketing">
                    <el-switch
                      v-model="customer.acceptsMarketing"
                      active-text="Yes"
                      inactive-text="No"
                    ></el-switch>
                  </el-form-item>
                </el-row>
                <el-form-item>
                  <el-button type="success" v-on:click.prevent="addCustomer">Add Customer</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-dialog
              title="Confirm Delete"
              :visible.sync="dialogVisible"
              width="30%"
              :modal="false"
            >
              <span>This will permanently delete the customer, are you sure?</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button type="danger" @click="deleteCustomer()">Yes Delete</el-button>
              </span>
            </el-dialog>
          </el-card>
        </el-col>

        <!-- LIST -->
        <el-col :span="16">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Existing customers</h4>
              <p
                class="category"
              >List of existing customers, you can use the search form above to search for a specific customer.</p>
              <br />
            </div>
            <div v-if="error">{{error}}</div>
            <div class="table-responsive">
              <data-tables-server
                class="table-shopping"
                style="width: 100%"
                :data="results.filter(data => !search || data.firstname.toLowerCase().includes(search.toLowerCase()))"
                :tool-bar="false"
                :current-page="1"
                :total="total"
                :loading="loadingCustomers"
                @query-change="loadData"
                :page-size="20"
                :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
              >
 
                <el-table-column label="ID" min-width="70">
                  <template slot-scope="props">{{props.row.id}}</template>
                </el-table-column>
                <el-table-column label="First Name" min-width="110">
                  <template slot-scope="props">{{props.row.firstname}}</template>
                </el-table-column>
                <el-table-column label="Last Name" min-width="110">
                  <template slot-scope="props">{{props.row.lastname}}</template>
                </el-table-column>
                <el-table-column label="Email" min-width="170">
                  <template slot-scope="props">{{props.row.email}}</template>
                </el-table-column>
                <!--<el-table-column
                  label="Last Login"
                  min-width="80"
                >
                  <template slot-scope="props">{{props.row.dateLogin}}</template>
                </el-table-column>-->
                <el-table-column label="Date Created" min-width="100" sortable="custom">
                  <template slot-scope="props">
                    <span
                      v-if="props.row.dateCreated != null"
                    >{{props.row.dateCreated | moment('DD/MM/YYYY')}}</span>
                  </template>
                </el-table-column>
                <el-table-column  min-width="150">
                  <template slot="header" slot-scope="scope">
                    <el-input
                      v-model="search"
                      style="padding:5px;font-weight:100"
                      suffix-icon="el-icon-search"
                      placeholder="Filter by Firstname"/>
                  </template>
                  <template slot-scope="props">
                    <router-link :to="'/customer/edit/'+props.row.id">Edit</router-link>
                  </template>
                </el-table-column>
                             
              </data-tables-server>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import gql from "graphql-tag";
export default {
  props: ["property", "value"],

  data() {
    return {
      search: '',
      loadingCustomers: false,
      customerTitles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Rev"],
      results: [],
      customer: {},
      dialogVisible: false,
      error: null,
      total: 0,
      rules: {
        firstname: [
          {
            required: true,

            message: "Please input name",
            trigger: "blur"
          }
        ],
        lastname: [
          {
            required: true,

            message: "Please input name",
            trigger: "blur"
          }
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "Please input correct email address",
            trigger: "change"
          }
        ]
      },
      titles: [
        {
          prop: "id",
          label: "ID"
        },
        {
          prop: "firstname",
          label: "Firstname"
        },
        {
          prop: "lastname",
          label: "Lastname"
        }
      ],
      searchDef: {
        show: true,
        props: "lastname"
      }
    };
  },

  methods: {
    toggleDialog(id) {
      this.dialogVisible = !this.dialogVisible;
    },

    async loadData(queryInfo) {
      this.loadingCustomers = true;

      if (queryInfo != undefined) {
        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = "desc_nulls_last";
        var orderProp = "dateCreated";

        (queryInfo.type === "page" ||
          queryInfo.type === "size" ||
          queryInfo.type === "sort") &&
          this.$message(
            `page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}`
          );

        if (queryInfo.sort.order === "ascending") {
          orderDir = "asc_nulls_last";
        } else if (queryInfo.sort.order === "descending") {
          orderDir = "desc_nulls_last";
        } else {
        }
        if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }
      } else {
        var type = "init";
        var page = 1;
        var pageSize = 20;
        var orderDir = "desc_nulls_last";
        var orderProp = "dateCreated";
      }

      console.log("queryinfo: ", queryInfo);
      console.log("loading data...");

      if (this.$props.property) {
        // if its an id which is a number ilike won't work
        let qWhere;
        if (this.$props.property == "id") {
          qWhere = `where:{id: {_eq: "${this.$props.value}"}}`;
        } else if (this.$props.property == "fullname") {
          var names = this.$props.value.split(" ");
          qWhere = `where: {_and: {firstname: {_ilike: "%${names[0]}%"}, lastname: {_ilike: "%${names[1]}%"}}}`;
        } else {
          qWhere = `where:{${this.$props.property}: {_ilike: "%${this.$props.value}%"}}`;
        }
        this.$apollo
          .query({
            // desc_nulls_last filters out any null data
            query: gql`
            {
              Customer(
                limit: ${pageSize}, 
                offset: ${(page - 1) * pageSize}, 
                order_by: {${orderProp}: ${orderDir}}, 
              
               ${qWhere}
              ) {
                  id
                  firstname
                  lastname
                  email
                  dateLogin
                  dateCreated
                }
                Customer_aggregate(
                 ${qWhere}
                ) {
                  aggregate {
                    count
                  }
                }
            }
          `,
            // can get error if needed
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            this.results = response.data.Customer;
            this.total = response.data.Customer_aggregate.aggregate.count;
            this.loadingCustomers = false;
          });
      } else {
        /// It's the list view  ///
        this.$apollo
          .query({
            // desc_nulls_last filters out any null data
            query: gql`
              {
                Customer(
                  limit: ${pageSize}, 
                  offset: ${(page - 1) * pageSize}, 
                  order_by: {${orderProp}: ${orderDir}},
                ) {
                  id
                  firstname
                  lastname
                  email
                  dateLogin
                  dateCreated
                }
                Customer_aggregate{
                  aggregate {
                    count
                  }
                }
            }
            `,
            // can get error if needed
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            this.results = response.data.Customer;
            this.total = response.data.Customer_aggregate.aggregate.count;
            this.loadingCustomers = false;
          });
      }
    }
  },
  watch: {
    "$route.params.value": function(value) {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Customers/Search.vue